import { render, staticRenderFns } from "./SetaParaDireita.vue?vue&type=template&id=afd31c58&scoped=true"
import script from "./SetaParaDireita.vue?vue&type=script&lang=js"
export * from "./SetaParaDireita.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afd31c58",
  null
  
)

export default component.exports